<div class="container">
  <div class="menuContainer">
    <ng-container *ngFor="let data of menuItems;">
      <nav *ngIf="data?.isRight">
        <ng-container *ngIf="data.isChild">
          <a class="menuLinks" [active]="data.active" [class.active]="data.active">
            <em class="{{data.icon}}"></em>
            <h5 [matMenuTriggerFor]="menu" (menuOpened)="data.showSubMenu = true" (menuClosed)="data.showSubMenu = false">{{data.name}}
              <span *ngIf="data.isChild" [ngClass]="data.showSubMenu ? 'up' : 'down'">
                <em class="icon-DownArrow"></em>
              </span>
            </h5>
            <mat-menu #menu="matMenu">
              <ng-container *ngFor="let submenuitem of data?.subMenu">
                <button *ngIf="submenuitem?.isRights" mat-menu-item (click)="subMenuClick(submenuitem)">
                  {{submenuitem.name}}
                </button>
              </ng-container>
            </mat-menu>
          </a>
        </ng-container>
        <ng-container *ngIf="!data.isChild">
          <a [active]="data.active" class="menuLinks" [routerLink]="[data.link]" [class.active]="data.active">
            <em class="{{data.icon}}"></em>
            <h5>{{data.name}} </h5>
          </a>
        </ng-container>
      </nav>
    </ng-container>
  </div>
</div>
